(() => {
  angular
    .module('gm.common.directives')
    .directive('gmyFormAlert', gmyFormAlert);

  function gmyFormAlert(
    $timeout,
    GmyUtils
  ) {
    'ngInject';

    const has = Object.prototype.hasOwnProperty;

    return {
      replace: true,
      restrict: 'E',
      scope: {
        ngMessages: '=?',
        showIf: '=?',
        time: '@',
        type: '@'
      },
      templateUrl: 'modules/common/directives/forms/form-alert/form-alert.html',
      transclude: true,
      link(scope, element, attrs) {
        const isEmptyFn = () => {
          scope.isEmpty = element.text().trim() === '';
        };
        const throttleIsEmptyFn = GmyUtils.throttle(isEmptyFn, 100);

        let _hideTimer = null;

        function cancelHideTimer() {
          if (_hideTimer) {
            $timeout.cancel(_hideTimer);
          }
          _hideTimer = null;
        }

        function onDestroy() {
          element.off('DOMNodeInserted DOMNodeRemoved', throttleIsEmptyFn);
        }

        function onShowIfChanged(newVal) {
          if (has.call(attrs, 'showIf')) {
            scope.showAlert = (newVal === true);

            if (newVal && scope.time > 0) {
              startHideTimer();
            } else {
              cancelHideTimer();
            }
          }
        }

        function startHideTimer() {
          cancelHideTimer();
          _hideTimer = $timeout(() => {
            scope.showIf = false;
          }, scope.time);
        }

        scope.isEmpty = false;
        scope.showAlert = false;
        if (has.call(attrs, 'showIf')) {
          scope.showAlert = scope.showIf;
        } else {
          scope.showAlert = true;
        }

        scope.time = ((!angular.isUndefined(scope.time)) && (angular.isNumber(scope.time)))
          ? scope.time
          : 0;

        if (angular.isUndefined(scope.type)) {
          scope.type = '';
        }

        element.on('DOMNodeInserted DOMNodeRemoved', throttleIsEmptyFn);
        scope.$watchCollection('showIf', onShowIfChanged);
        scope.$on('$destroy', onDestroy);

        isEmptyFn();
      }
    };
  }
})();
